import React, {useState, useEffect} from 'react';
import styled, {keyframes} from 'styled-components';
import SectionHeader from './SectionHeader';
import SectionDetails from './SectionDetails';
import SingleClubEventDate from './clubevents/SingleClubEventDate';
import ComingUpSingleEvent from './comingup/ComingUpSingleEvent';
import ReservationEvent from './ReservationEvent';
import Contact from './Contact';
import Footer from './Footer';
import Social from './Social';
import Copyright from './Copyright';
import Navigation from './Navigation';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faChevronLeft} from '@fortawesome/free-solid-svg-icons'
import {Link, useParams, useLocation, useNavigate} from 'react-router-dom';
import {Trans, withTranslation, useTranslation,} from "react-i18next";
import Helmet from "react-helmet";
import events from "../components/clubevents/events.json";
import GoogleAnalytics from '../GoogleAnalytics';
import ReactPixel from 'react-facebook-pixel';

const Wrapper = styled.div`
    padding-top: 150px;
    padding-bottom: 150px;
`;

const BackLink = styled.div`
    font-family: 'Montserrat', sans-serif;
    font-size: 1.3em;
    font-weight: bold;
    font-weight: 300;
    letter-spacing: -1px;
    -webkit-font-smoothing: antialiased;
    float: left;
    margin-top: 100px;
    margin-left: 16%;
    padding-bottom: 150px;

    &:hover {
        opacity: .8;
        cursor: pointer;
    }
`;

const StyledCover = styled.img`
    position: relative;
    top: -50px;
    display: block;
    width: 50%;
    margin: 0 auto;
    @media (max-width: 1200px) {
        width: 90%;
    }
`

const NyeInfo = styled.img`
    position: relative;
    top: 50px;
    padding-bottom: 50px;
    display: block;
    width: 50%;
    margin: 0 auto;
    @media (max-width: 1200px) {
        width: 90%;
    }
`

const StyledGradient = styled.div`
    display: block;
    height: 10px;
    background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0), rgba(0, 0, 0, 1));
    position: fixed;
    bottom: 70px;
    width: 100%;
    z-index: 1000;
    @media (max-width: 1200px) {
        width: 100%;
        bottom: 50px;
    }
`;

const StyledBack = styled.a`
    font-family: "Lora";
    font-size: 1.7em;
    font-weight: 600;
    text-align: center;
    padding: 10px;
    -webkit-font-smoothing: antialiased;
    color: #c1c1c1;
    position: fixed;
    display: block;
    background-color: black;
    bottom: 0;
    height: 50px;
    z-index: 1000;
    width: 100%;
    @media (max-width: 1200px) {
        padding: 0px;
        font-size: 1.4em;
        text-align: center;
    }

    &:hover {
        opacity: .9;
        cursor: pointer;
    }
`;

const StyledBackSpan = styled.a`
    opacity: .6;
`;

function findEventById(date) {
    return events.find((event) => {
        return event.date === date;
    })
}

function Capitalize(str) {
    const string = str.charAt(0).toUpperCase() + str.slice(1);
    return <Trans>{string}</Trans>;
}

function GetParams() {
    return useParams();
}

function GetEvent() {
    return events.find(e => e.date === GetParams().date);
}

function EventPage() {
    const location = useLocation();
    const {t, i18n} = useTranslation();
    ReactPixel.init('1576304659568289');
    ReactPixel.pageView();

    const navigate = useNavigate();

    function NavigateBackToEvents() {
        return navigate("../../../" + i18n.language + "/events", {relative: "path"});
    }

    const event = GetEvent();
    const [isPastEvent, setIsPastEvent] = useState(true);
    const today = new Date();

    if (event === undefined || event === null) {
        navigate("..", {relative: "path"});
    } else {
        const eventDate = new Date(event.utfDate);

        useEffect(() => {
            if (today < eventDate) {
                setIsPastEvent(false)
            }
        }, [eventDate]);

        const [isVisible, setIsVisible] = useState(false);

        useEffect(() => {
            window.addEventListener("scroll", listenToScroll);
            return () =>
                window.removeEventListener("scroll", listenToScroll);
        }, []);

        const listenToScroll = () => {
            let heightToHideFrom = 500;
            const winScroll = document.body.scrollTop ||
                document.documentElement.scrollTop;
            if (winScroll > heightToHideFrom) {
                setIsVisible(true);
            } else {
                setIsVisible(false);
            }
        };
        const language = i18n.language;
        return (
            <Wrapper>
                <GoogleAnalytics/>
                {event.image ? (
                    <StyledCover src={event.image} alt={event.name + " " + event.date}
                                 title={event.name + " " + event.date}/>
                ) : null}
                <Helmet>
                    <meta property="og:image" content={"https://www.culturebeatclub.com" + event.image}/>
                    <meta property="og:title" content={t(event.name)}/>
                    <meta property="og:url"
                          content={"https://www.culturebeatclub.com/" + i18n.language + "/events/" + event.date}/>
                    <meta property="og:description" content={t(event.name + ", " + event.dj + ", " + event.date)}/>
                    <meta property="og:site_name" content="Culture Beat Club (Кълчър Бийт) - Sofia, Bulgaria"/>
                    <meta property="og:type" content="website"/>
                    <html lang={i18n.language}/>
                    <meta charSet="utf-8"/>
                    <title>{t(event.name)}</title>
                    <meta name="description" content={t(event.name + " " + event.dj + " " + event.date)}/>
                    <link rel="canonical"
                          href={"https://www.culturebeatclub.com/" + i18n.language + "/events/" + event.date}/>
                    <script type="application/ld+json">
                        {JSON.stringify({
                            "@context": "https://schema.org",
                            "@type": "Event",
                            "name": event.name + " with " + event.dj,
                            "startDate": event.utfDate,
                            "endDate": event.utfEndDate,
                            "eventAttendanceMode": "https://schema.org/MixedEventAttendanceMode",
                            "eventStatus": "https://schema.org/EventScheduled",
                            "location": [
                                {
                                    "@type": "Place",
                                    "url": "https://www.culturebeatclub.com/",
                                    "name": "Culture Beat Club",
                                    "address": {
                                        "@type": "PostalAddress",
                                        "streetAddress": "1 Bulgaria Square, National Palace Of Culture",
                                        "addressLocality": "Sofia",
                                        "postalCode": "1000",
                                        "addressCountry": "BG"
                                    }
                                }],
                            "image": [
                                event.image
                            ],
                            "description": event.name + " with " + event.dj,
                            "performer": {
                                "@type": "Person",
                                "name": event.dj
                            },
                            "organizer": {
                                "@type": "Organization",
                                "name": "Culture Beat Club",
                                "url": "https://www.culturebeatclub.com/"
                            }
                        })}
                    </script>
                </Helmet>
                <Navigation/>
                <SectionHeader title={event.name}/>
                <SectionDetails title={event.dj}/>

                <ComingUpSingleEvent event={event}/>
                {isPastEvent ? (
                    <SectionHeader title={<Trans>Past Event</Trans>}/>
                ) : null}
                {event.type === "FULLY_BOOKED" && !isPastEvent ? (
                    <SectionHeader title={<Trans>Fully Booked</Trans>}/>
                ) : null}
                {event.type === "NYE_PARTY" && i18n.language === "bg" ? (
                        <div>
                            <h1>✨ Посрещни Нова година там, където купонът никога не спира! 🍾</h1>

                            <p>Каним те на нашето <strong>BEST OF THE YEAR PARTY</strong> със звездни сетове от <strong>Dj
                                Groovy & Dj Makko</strong>. 📀</p>

                            <h2>🎟️ КУВЕРТ ЗА "NYE 2026"</h2>

                            <ul style={{listStyleType: "none"}}>
                                <li>Вход</li>
                                <li>1 брой малка напитка</li>
                                <li>2 броя безалкохолни напитки</li>
                                <li>1 чаша шампанизирано вино</li>
                                <li>1 порция ядки или маслини</li>
                            </ul>

                            <p><strong>⚠️ Не включва:</strong> висок клас алкохолни и енергийни напитки.</p>

                            <h2>💸 ЦЕНИ НА КУВЕРТА:</h2>

                            <ul style={{listStyleType: "none"}}>
                                <li><strong>Early Bird</strong> (до 30 ноември) – <strong>100 лв.</strong></li>
                                <li><strong>Стандартен</strong> (от 1 декември) – <strong>120 лв.</strong></li>
                            </ul>

                            <p><strong>❗ Кувертът трябва да бъде заплатен до два дни след направената резервация.</strong>
                            </p>

                            <p><strong>⚠️ Преди 00:30 няма да се допускат лица без закупен куверт.</strong></p>

                            <p>🕐 Вход след 00:30 часа за лица без куверт: <strong>40 лв.</strong></p>
                        </div>


                    ) : null}
                {event.type === "NYE_PARTY" && i18n.language === "en" ? (
                    <div>
                        <h1>✨ Welcome the New Year where the party never stops! 🍾</h1>

                        <p>Join us for our <strong>BEST OF THE YEAR PARTY</strong> with stellar DJ sets by <strong>DJ
                            Groovy & DJ Makko</strong>. 📀</p>

                        <h2>🎟️ "NYE 2026" PACKAGE</h2>

                        <ul style={{listStyleType: "none"}}>
                            <li>Entrance</li>
                            <li>1 small drink</li>
                            <li>2 soft drinks</li>
                            <li>1 glass of sparkling wine</li>
                            <li>1 portion of nuts or olives</li>
                        </ul>

                        <p><strong>⚠️ Does not include:</strong> premium alcoholic beverages and energy drinks.</p>

                        <h2>💸 PACKAGE PRICES:</h2>

                        <ul style={{listStyleType: "none"}}>
                            <li><strong>Early Bird</strong> (until November 30) – <strong>100 BGN</strong></li>
                            <li><strong>Standard</strong> (from December 1) – <strong>120 BGN</strong></li>
                        </ul>

                        <p><strong>❗ The package must be paid within two days after making a reservation.</strong></p>

                        <p><strong>⚠️ Before 00:30, entry without a purchased package will not be allowed.</strong></p>

                        <p>🕐 Entry after 00:30 for guests without a package: <strong>40 BGN</strong></p>
                    </div>
                ) : null }
                {event.type !== "FULLY_BOOKED" && !isPastEvent && event.type !== "PRIVATE_PARTY" ? (
                    <ReservationEvent event={event}/>
                ) : null}
                {isVisible ? (
                    <StyledBack onClick={() => NavigateBackToEvents()}>
                        <StyledBackSpan>
                            <FontAwesomeIcon size="lg" icon={faChevronLeft}/>
                            <Link to="/"> <Trans>BACK TO EVENTS</Trans></Link>
                        </StyledBackSpan>
                        <StyledGradient/>
                    </StyledBack>
                ) : null}
                <Copyright/>
            </Wrapper>
        );
    }
}

export default withTranslation()(EventPage);